import {
	Button as KendoButton,
	ButtonGroup,
} from "@tql/ui-components-react/kendo/buttons";
import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { undoIcon } from "@tql/ui-components-react/kendo/svg-icons";
import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	alertTriangle,
	creditCard_01,
} from "@tql/ui-components-react/untitled/icons";
import { format, isValid } from "date-fns";
import { useState } from "react";
import { useParams } from "react-router";

import type { AugmentedShipment } from "../../types/augmented-shipment.ts";
import { isSentToAccounting } from "../../utils/get-status-lock-label.ts";
import { BillHoldModal } from "../bill-hold-modal/index.tsx";
import { SendToAccountingModal } from "../send-to-accounting-modal/index.tsx";
import { UnmarkDeliveredModal } from "../unmark-delivered-modal/index.tsx";

export const DeliveredGroup = ({
	shipment,
}: {
	shipment: AugmentedShipment;
}) => {
	const params = useParams();
	const [isBillHoldOpen, setIsBillHoldOpen] = useState(false);
	const [isSendToAccountingOpen, setIsSendToAccountingOpen] = useState(false);
	const [isUnmarkDeliveredOpen, setIsUnmarkDeliveredOpen] = useState(false);
	const sentToAccounting = isSentToAccounting(shipment);
	const actualDelivery = shipment?.shipmentDetails?.delivery?.actual;
	const actualDeliveryDate = actualDelivery ? new Date(actualDelivery) : null;
	const deliveryDate =
		actualDeliveryDate && isValid(actualDeliveryDate)
			? format(actualDeliveryDate, "MMM d, yyyy h:mm a")
			: "";
	return (
		<div className={"delivered-group"}>
			<div className={"delivery-info-row"}>
				<div className={"delivery-info-column"}>
					<div className={"delivery-label"}>Delivery Date:</div>
					<div className={"delivery-value"}>{deliveryDate}</div>
				</div>

				<div className={"delivery-info-column"}>
					<div className={"delivery-label"}>Delivery Status:</div>
					<div className={"delivery-value"}>On Time</div>
				</div>
			</div>

			<ButtonGroup className={"shipment-button-group"}>
				<div className={"button-row"}>
					<div className={"button-success"}>
						<Button
							disabled={sentToAccounting}
							onClick={() => setIsSendToAccountingOpen(true)}
							variant={"secondary"}
						>
							<SvgIcon
								className={"shipment-progress-icon"}
								icon={creditCard_01}
							/>
							{sentToAccounting ? "Sent to Accounting" : "Send to Accounting"}
						</Button>
					</div>
					<Button
						disabled={sentToAccounting}
						onClick={() => setIsUnmarkDeliveredOpen(true)}
						variant={"secondary"}
					>
						<SvgIcon className={"shipment-progress-icon"} icon={undoIcon} />
						Unmark Delivered
					</Button>
				</div>
				{shipment?.customer?.isBillHoldCustomer ? (
					// eslint-disable-next-line @typescript-eslint/no-deprecated -- TQL Button has no warning variant
					<KendoButton
						fillMode={"outline"}
						onClick={() => setIsBillHoldOpen(true)}
						rounded={"medium"}
						themeColor={"warning"}
						type={"button"}
					>
						<SvgIcon
							className={"shipment-progress-icon"}
							icon={alertTriangle}
						/>
						Bill Hold
					</KendoButton>
				) : null}
			</ButtonGroup>
			<SendToAccountingModal
				isOpen={isSendToAccountingOpen}
				onClose={() => setIsSendToAccountingOpen(false)}
				poNumber={String(params["poNumber"])}
			/>
			<UnmarkDeliveredModal
				isOpen={isUnmarkDeliveredOpen}
				onClose={() => setIsUnmarkDeliveredOpen(false)}
				poNumber={String(params["poNumber"])}
			/>
			<BillHoldModal
				isOpen={isBillHoldOpen}
				onClose={() => setIsBillHoldOpen(false)}
				shipment={shipment}
			/>
		</div>
	);
};
